var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddToCalendarButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Add_to_Calendar_Button",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4233",
    "data-name": "Path 4233",
    d: "M16,1.458A14.542,14.542,0,1,1,1.458,16,14.56,14.56,0,0,1,16,1.458M16,0A16,16,0,1,0,32,16,16,16,0,0,0,16,0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4234",
    "data-name": "Path 4234",
    d: "M61,52.271H53.729V45H52.271v7.271H45v1.458h7.271V61h1.458V53.729H61Z",
    transform: "translate(-37 -37)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToCalendarButton);
export default __webpack_public_path__ + "static/media/Add_to_Calendar_Button.6e602bd0.svg";
export { ForwardRef as ReactComponent };